/** @jsx jsx */
import { jsx } from "frontend/src/utils/jsx"
import { createContext, useContext } from "react"

const LocationContext = createContext({
  href: "",
  origin: "",
  protocol: "",
  host: "",
  hostname: "",
  port: "",
  pathname: "",
  search: "",
  hash: "",
  state: null,
  key: "",
})

function useLocation() {
  return useContext(LocationContext)
}

function LocationProvider({ children, location }) {
  return <LocationContext.Provider value={location}>{children}</LocationContext.Provider>
}

export { LocationProvider, useLocation }
